import { Component, OnInit, ViewChild } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import {SharedService} from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router, NavigationExtras} from "@angular/router";
import {MatSnackBar} from '@angular/material/snack-bar';
import {Location} from '@angular/common';
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  showOverlay = false;
  loading = false;
  initialLoad = true;

  getLanguage():string{
    if (localStorage){
        return localStorage['language'] || "";
    }
    else{
        return "";
    }
}

setLanguage(language: string){
    if (localStorage){
        localStorage['language'] = language;
    }
}

constructor(private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _snackBar: MatSnackBar, private location: Location) { 

  translate.addLangs(['en', 'ro']);
  translate.setDefaultLang('en');

  const browserLang = this.getLanguage();
  translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');

  this.router.routeReuseStrategy.shouldReuseRoute = function () {
    return false;
  };

    // Debounce search.
    this.searchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.GetSearchResults(value);
      });

}

public BackendServiceUrl = this.service.APIUrl;
public AppPIN:string;
searchTermUpdate = new Subject<string>();

IsMultiApp:boolean = true;

User:any;
Company:any;
mainCurrency:any;
masterData:any;
ShowEmailSendContainer:boolean;
ShowEmailBulkSendContainer:boolean;
Partner:any;
CompanyNotificationPager:any;
CompanyNotificationOnlyUnSeen:boolean;
UnseenCompanyNotificationPager:boolean;
CompanyNotifications:any[];

showAddNewPartnerPopUp:boolean;
showEditPartnerPopUp:boolean;
showContent:boolean;
generalSearchTerm:string;
ReceptionsSearchResults:any[];
PurchaseContractsSearchResults:any[];
InvoiceSearchResults:any[];
SpendingsSearchResults:any[];
CashCollectionsSearchResults:any[];
SearchResultTypes:any[];
SendEmailWithAttachment:boolean;
SearchInProducts:boolean;
LocalEnviormentWithLiveAPIWarning:boolean;

AppVersion:string = "1.10.31.08.22";
Applications:any[];
CurrentApp:any;
AuxCurrentApp:any;

ngOnInit(): void {

   this.TestEnviorment();
   this.TestNetConnection();
   this.SetDefaultLanguage();
   this.User = JSON.parse(localStorage.getItem("User"));

   if(this.User == null){
    this.RedirectToURLWithUrlChange('login');
   }
   else{

    if(this.User.LastLogin == null || this.User.LastLogin?.length == 0){
      this.LogOff();
    }

    this.User.Rights.AssignedCompanies.forEach(element => {
      if(element.IsSelected == true){
        this.Company = element;
      }

      this.SearchResultTypes = this.User.Settings.SearchResultTypes.filter(x => x.IsSelected == true && x.ID != 0);
      this.SearchInProducts = this.User.Settings.SearchInProducts;
    });
   }

   //get master data
   var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetMasterData(request).subscribe(response => {

   if(response["Status"] != 1){
   
   }
   else if(response["Status"] == 1){
    this.masterData = response;
    this.Applications = response["Applications"];
    this.GetSetApplicationByUrl();
   }

   this.loading = false;
   this.GetMainCurrency();
   
 },
 (err) => {
  this.translate.get("ServerConnectionError").subscribe((resource: string) => {
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
  });
 });

   this.CompanyNotificationPager = {
     PageIndex:1,
     PageSize:50,
     Pages:0,
     TotalCount:0
   };
   this.CompanyNotificationOnlyUnSeen = null;

   this.GetUserAssignedCompanies();
   this.SendEmailWithAttachment = true;
   this.GetCompanyNotificationsFilteredCOUNT(false, true);
}

//tests if we are on local or live API Urls from Service
//it is set to warn if we are on local and api is on live
TestEnviorment(){

  var fullpath = this.router['location']._platformLocation.location.origin;

  if(!this.service.APIUrl.includes("localhost") && fullpath.includes("localhost")){
    this.LocalEnviormentWithLiveAPIWarning = true;
  }
}

PreventBrowserClose(prevent:any){

  var url = this.router.url;
   
  if(prevent == true){
    window.addEventListener("beforeunload", function PreventAccidentalClose(e) {
      var confirmationMessage = "\o/";
      var currentURL = this.window.location.href.replace(this.window.location.origin, "");
    
      if(currentURL == url){
        (e || window.event).returnValue = confirmationMessage; //Gecko + IE
        return confirmationMessage;                            //Webkit, Safari, Chrome
      }
    });
  }
}

TestNetConnection(){

  if(navigator.onLine == false){
    this.translate.get("OfflineConnection").subscribe((resource: string) => {
      this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
    });
   }
}

GetMainCurrency(){
  this.mainCurrency = this.Company?.Addresses[0]?.Country?.Currency;
}

newGuid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxxxxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

getUrlWithoutParams(){
  let urlTree = this.router.parseUrl(this.router.url);
  urlTree.queryParams = {}; 
  return urlTree.toString();
}

CheckUserRouteAccess(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams(),
  };

  this.loading = true;

 this.service.CheckUserRouteAccess(request).subscribe(response => {

  if(response["Status"] != 1){
    this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){

    if(response["HasAccess"] == true && response["CurrentAppAccess"] == true){
      this.showContent = true;
    }
    else{
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");

      setTimeout(() => {
        window.location.replace('login');
      }, 2000);
    }
   }

   this.initialLoad = false;
   this.loading = false;
 },
 (err) => {
  this.translate.get("ServerConnectionError").subscribe((resource: string) => {
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
  });
 });

}

GetSetApplicationByUrl(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    uri:this.getUrlWithoutParams()
  };

  this.loading = true;

 this.service.GetSetApplicationByUrl(request).subscribe(response => {

   if(response["Status"] != 1){
    this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
   }
   else if(response["Status"] == 1){
    var currentURL = response["URL"];
    this.CurrentApp = currentURL.Application;

    this.User.Rights.Application = currentURL.Application;
    this.User.AppAccess.forEach(AppAccess => {
      if(AppAccess.Application.ID == this.CurrentApp.ID){
        AppAccess.IsSelected = true;
      }
      else{
        AppAccess.IsSelected = false;
      }
    });
    
    localStorage.setItem('User', JSON.stringify(this.User));

    if(this.User.Rights.Application.RequiresToken == true){
      let MFATokenCookie:any = this.cookieService.get('MFAuthToken');

      if(!MFATokenCookie){
        this.RedirectToURLWithUrlChange('login/MFA');
      }
    }

   }

   this.CheckUserRouteAccess();
   this.loading = false;
 },
 (err) => {
  this.translate.get("AppIdentificationError").subscribe((resource: string) => {
    this.openSnackBar(resource, "OK", "alert-info-snackbar", 20000000);
  });
 });

}

GetUserAssignedCompanies(){

  var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetUserAssignedCompanies(request).subscribe(response => {

   if(response["Status"] != 1){
   
   }
   else if(response["Status"] == 1){
     this.User.Rights.AssignedCompanies = response["AssignedCompanies"];
   }

   this.loading = false;
   
 });
}

GetMasterData(){
  var request = {
    User:this.User,
    Language:this.getLanguage()
 };

 this.loading = true;

 this.service.GetMasterData(request).subscribe(response => {

   if(response["Status"] != 1){
   }
   else if(response["Status"] == 1){
    this.masterData = response;
   }

   this.loading = false;
 });
}

SetDefaultLanguage(){

  if(this.getLanguage() == ''){
    this.setLanguage("en");
  }
}

openSnackBar(message: string, action: string, designClass: string, duration:number = 5000) {
  this._snackBar.open(message, action, {
    duration: duration,
    panelClass: [designClass]
  });
}

RedirectToURL(url: string){
   this.router.navigateByUrl('/', {skipLocationChange: false}).then(()=>
   this.router.navigate([url]));
}

RedirectToURLNewTab(url: string) {
  window.open(url, '_blank');
}

showLoggOffContainer:boolean;

OpenLogOff(){
  this.showLoggOffContainer = true;
}

LogOff(){
  this.loading = true;
  localStorage.removeItem("User");
  this.cookieService.delete("MFAuthToken", "/");
  window.location.reload();
}

ChangeMainCompany(company:any){

  this.User.Rights.AssignedCompanies.forEach(element => {
    element.IsSelected = false;

    if(element.ID == company.ID){
      element.IsSelected = true;
    }

    localStorage.setItem('User', JSON.stringify(this.User));
    this.Company = company;

    this.UpdateUserLastUsedCompany(company.ID);
  });
}

//menu
//management MENU section

showManagementMenu:boolean;
showMyAccountMenu:boolean;
showPurchasesMenu:boolean;
showSalesMenu:boolean;
showDocumentsMenu:boolean;
showReportsMenu:boolean;
showSettingsMenu:boolean;
showCCPMenu:boolean;

CloseDashMenu(){

  this.searchTermUpdate.next('');
  this.isSearchActive = false;
  this.ReceptionsSearchResults = [];
  this.PurchaseContractsSearchResults = [];
  this.InvoiceSearchResults = [];
  this.SpendingsSearchResults = [];
  this.CashCollectionsSearchResults = [];

  this.generalSearchTerm = "";
  this.showManagementMenu = false;
  this.showMyAccountMenu = false;
  this.showPurchasesMenu = false;
  this.showDocumentsMenu = false;
  this.showReportsMenu = false;
  this.showSettingsMenu = false;
  this.showSalesMenu = false;
  this.ShowNotificationCenter = false;
  this.showCCPMenu = false;
  this.showSalesMenu = false;
}

OpenMenu(menu:string){

  if(menu == "management"){
    this.showManagementMenu = !this.showManagementMenu;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = false;
    this.showReportsMenu = false;
    this.showSettingsMenu = false;
    this.showSalesMenu = false;
    this.showCCPMenu = false;
  }
  else if(menu == "myaccount"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = !this.showMyAccountMenu;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = false;
    this.showReportsMenu = false;
    this.showSettingsMenu = false;
    this.showSalesMenu = false;
    this.showCCPMenu = false;
  }
  else if(menu == "purchases"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = !this.showPurchasesMenu;
    this.showDocumentsMenu = false;
    this.showReportsMenu = false;
    this.showSettingsMenu = false;
    this.showSalesMenu = false;
    this.showCCPMenu = false;
  }
  else if(menu == "documents"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = !this.showDocumentsMenu;
    this.showReportsMenu = false;
    this.showSettingsMenu = false;
    this.showSalesMenu = false;
    this.showCCPMenu = false;
  }
  else if(menu == "reports"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = false;
    this.showReportsMenu = !this.showReportsMenu;
    this.showSettingsMenu = false;
    this.showSalesMenu = false;
    this.showCCPMenu = false;
  }
  else if(menu == "settings"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = false;
    this.showReportsMenu = false;
    this.showSettingsMenu = !this.showSettingsMenu;
    this.showSalesMenu = false;
    this.showCCPMenu = false;
  }
  else if(menu == "mysales"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = false;
    this.showReportsMenu = false;
    this.showSettingsMenu = false;
    this.showSalesMenu = !this.showSalesMenu;
    this.showCCPMenu = false;
  }
  else if(menu == "myccpayments"){
    this.showManagementMenu = false;
    this.showMyAccountMenu = false;
    this.showPurchasesMenu = false;
    this.showDocumentsMenu = false;
    this.showReportsMenu = false;
    this.showSettingsMenu = false;
    this.showSalesMenu = false;
    this.showCCPMenu = !this.showCCPMenu;
  }
}

isSearchActive:boolean;

toggleSearch(){
  this.isSearchActive = true;
  this.GetSearchResults(this.generalSearchTerm);
}

GetSearchResults(searchTerm:string){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Company:this.Company,
    SearchTerm:searchTerm,
  };

  if(this.generalSearchTerm != null && this.generalSearchTerm.length > 2){
    this.loading = true;

    this.service.GetSearchResults(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ReceptionsSearchResults = response["ReceptionsSearchResults"];
        this.PurchaseContractsSearchResults = response["PurchaseContractsSearchResults"];
        this.InvoiceSearchResults = response["InvoiceSearchResults"];
        this.SpendingsSearchResults = response["SpendingsSearchResults"];
        this.CashCollectionsSearchResults = response["CashCollectionsSearchResults"];
      }
   
      this.loading = false;
      
    });
  }
}

AutoPrintDocument(exportedDocument:any){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Document:exportedDocument
  };

    this.loading = true;

    this.service.AutoPrintDocument(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar", 20000);
      }
      else if(response["Status"] == 1){
        this.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.loading = false;
      
    });
}

printPage(name:string, html:string, ID:string) {
  var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  'resizable,screenX=50,screenY=50,width=850,height=1050';

var htmlPop = '<embed width=100% height=100%'
  + ' type="application/pdf"'
  + ' src="data:application/pdf;base64,'
  + escape(html)
  + '"></embed>';

var newWindow = window.open("", 'PDF_' + name +"_"+ ID);
newWindow.document.write(htmlPop);
};

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

PrintSearchDocument(DocumentID:string, DocumentType:number){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Company:this.Company,
    DocumentID:DocumentID,
    DocumentType:DocumentType
  };

  this.isSearchActive = false;
  this.loading = true;

    this.service.PrintSearchDocument(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.printPage(Document.Name , Document.PDFStream, Document.ID);
      }
   
      this.isSearchActive = true;
      this.loading = false;
      
    });
}

ExportSearchDocument(DocumentID:string, DocumentType:number){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Company:this.Company,
    DocumentID:DocumentID,
    DocumentType:DocumentType
  };

  this.isSearchActive = false;
  this.loading = true;

    this.service.PrintSearchDocument(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var Document = response["Document"];
        this.download(Document.Name, Document.PDFStream);
      }
   
      this.isSearchActive = true;
      this.loading = false;
      
    });
}

ModifySearchDocument(DocumentID:string, DocumentType:number){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Company:this.Company,
    DocumentID:DocumentID,
    DocumentType:DocumentType
  };

  this.isSearchActive = false;
  this.loading = true;

    this.service.GetSearchDocumentUrl(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ViewDocument(DocumentID, response["DocumentUrl"])
      }
   
      this.CloseDashMenu();
      this.loading = false;
      
    });
}

ViewDocument(id:any, url:string){
  this.router.navigate([url], { queryParams: { id: id }, replaceUrl: true }); 
}

OpenNewInvoice(url:string){
  this.router.navigate([url], { queryParams: { Type: 0 }, replaceUrl: true }); 
}

OpenNewProformaInvoice(url:string){
  this.router.navigate([url], { queryParams: { Type: 1 }, replaceUrl: true }); 
}

OpenNewAdvanceInvoice(url:string){
  this.router.navigate([url], { queryParams: { Type: 2 }, replaceUrl: true }); 
}

compareMultipleFn(o1: any, o2: any): boolean {
  
  // if possible compare by object's name property - and not by reference.
  return o1 && o2 ? o1.ID === o2.ID : o2 === o2;
}

lastSelected:boolean;

compareFn(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

changeSearchResultSelection(event){
  this.lastSelected = event.source._selected;
}

UpdateSearchResultTypeSelection(s:any){
  s.IsSelected = this.lastSelected;

  this.User.Settings.SearchResultTypes.forEach(element => {
    if(element.ID == s.ID){
      element.IsSelected = s.IsSelected;
    }
  });

  localStorage.removeItem('User');
  localStorage.setItem('User', JSON.stringify(this.User));
}

UpdateSearchInProductsSetting(){
  this.User.Settings.SearchInProducts = !this.SearchInProducts;
  localStorage.removeItem('User');
  localStorage.setItem('User', JSON.stringify(this.User));
}

InitializeEmailSendContainer(p:any, gdtype:any, documentID:any){
  this.Partner = p;
  this.GeneralDocType = gdtype;
  this.EmailDocumentID = documentID;
  this.GetCompanySMTPConfigs();
  this.EmailMessage.SendWithAttachment = true;
  this.ShowEmailSendContainer = true;
}

InitializeEmailBulkSendContainer(p:any, gdtype:any, Documents:any[]){
  this.Partner = p;
  this.GeneralDocType = gdtype;
  this.EmailDocuments = Documents;
  this.GetCompanySMTPConfigs();
  this.EmailMessage.SendWithAttachment = true;
  this.ShowEmailBulkSendContainer = true;
}

GeneralDocType:any;
SMTPConfigs:any[];
SMTPEmails:any[];
CurrenctSMTP:any;
CurrentSMTPEmail: {[k: string]: any} = {};
EmailMessage: {[k: string]: any} = {};
EmailDocumentID:any;
EmailDocuments:any[];

GetCompanySMTPConfigs(){
  var request = {
    User:this.User,
    Language:this.Partner.BillingAddress.Country.Language.Name,
    UILanguage:this.getLanguage(),
    CompanyID:this.Company.ID
  };

  this.loading = true;

  this.service.GetCompanySMTPConfigs(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPConfigs = response["SMTPConfigs"];

      if(this.SMTPConfigs.length > 0){
        this.CurrenctSMTP = this.SMTPConfigs[0];
        this.GetCompanySMTPEmails(this.CurrenctSMTP.ID);
      }
    }
   
    this.loading = false;
  });
}

GetCompanySMTPEmails(SMTPID:any){
  var request = {
    User:this.User,
    Language:this.Partner.BillingAddress.Country.Language.Name,
    UILanguage:this.getLanguage(),
    SMTPID:SMTPID
  };

  this.loading = true;

  this.service.GetCompanySMTPEmails(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SMTPEmails = response["Emails"];

      if(this.SMTPEmails.length > 0){
        this.CurrentSMTPEmail = this.SMTPEmails?.filter(x => x.IsDefault == true)[0];

        if(this.CurrentSMTPEmail == null){
          this.CurrentSMTPEmail = this.SMTPEmails[0];
        }

        this.EmailMessage.GeneralDocType = this.GeneralDocType;
        this.EmailMessage.EmailModel = {};
        this.EmailMessage.EmailModel = this.CurrentSMTPEmail;
        this.EmailMessage.DocumentID = this.EmailDocumentID;
        this.EmailMessage.SMTPServer = this.CurrenctSMTP.SMTPServer;
        this.EmailMessage.Port = this.CurrenctSMTP.Port;

        this.GenerateDocumentEmailSubject();
      }
    }
   
    this.loading = false;
  });
}

GenerateDocumentEmailSubject(){
  var request = {
    User:this.User,
    Language:this.Partner.BillingAddress.Country.Language.Name,
    GeneralDocType:this.GeneralDocType,
    DocumentID:this.EmailDocumentID
  };

  this.loading = true;

  this.service.GenerateDocumentEmailSubject(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.EmailMessage.EmailModel.Subject = response["Subject"];
      this.EmailMessage.EmailModel.DefaultMessage = response["Body"];
      this.EmailMessage.ToEmail = response["ToEmail"];
    }
   
    this.loading = false;
  });
}

ChangeSMTP(SMTP:any){
  this.GetCompanySMTPEmails(SMTP.ID);
}

SendDocumentEmail(){

  var request = {
    User:this.User,
    Language:this.Partner.BillingAddress.Country.Language.Name,
    EmailMessage:this.EmailMessage,
  };

  var Subject = JSON.parse(JSON.stringify(this.EmailMessage?.EmailModel?.Subject));
  var DefaultMessage = JSON.parse(JSON.stringify(this.EmailMessage?.EmailModel?.DefaultMessage));

  if(this.Partner.ContactInfo.Email != null){
    request.EmailMessage.ToEmail = this.Partner.ContactInfo.Email;
  }

  if(this.CurrentSMTPEmail != null){
    request.EmailMessage.EmailModel = this.CurrentSMTPEmail;
  }

  if (!this.EmailMessage?.EmailModel?.Subject) {
    this.EmailMessage.EmailModel.Subject = Subject;
  }

  if (!this.EmailMessage?.EmailModel?.DefaultMessage) {
    this.EmailMessage.EmailModel.DefaultMessage = DefaultMessage;
  }

  this.loading = true;

  this.service.SendDocumentEmail(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.openSnackBar("Success", "OK", "light-info-snackbar");
      this.ShowEmailSendContainer = false;
    }
   
    this.loading = false;
  });

}

NormalizePrice(stringValue:string) {

  stringValue = this.SwapDotAndComma(stringValue);
  var precision = this.countDecimals(stringValue);

  if(precision == null || precision < 2){
    precision = 2;
  }
  else if(precision > 4){
    precision = 4;
  }

  if(stringValue == null || stringValue == undefined || stringValue.length == 0){
    return 0;
  }

  stringValue = stringValue.replace(/[^\d.-]/g, '');
  stringValue = this.ProofNormalizationLastCharacters(stringValue);

  stringValue = stringValue.replace(/\s/g, '');
  stringValue = stringValue.trim();
  var result = stringValue.replace(/[^0-9]/g, '');
  
   if(precision == 2){
    if (/[,\.]\d{2}$/.test(stringValue)) {
      result = result.replace(/(\d{2})$/, '.$1');
    }
  }
  else if(precision == 3){
    if (/[,\.]\d{3}$/.test(stringValue)) {
      result = result.replace(/(\d{3})$/, '.$1');
    }
  }
  else if(precision == 4){
    if (/[,\.]\d{4}$/.test(stringValue)) {
      result = result.replace(/(\d{4})$/, '.$1');
    }
  }
 
  var final = parseFloat(result);

  if(isNaN(final)){
    return 0;
  }

  return final;
}

countDecimals = function (x) {
  if(Math.floor(this.valueOf(x)) === this.valueOf(x)) return 0;
  return x.toString().split(".")[1].length || 0; 
}

SwapDotAndComma(s) : string {
  
  var stringValue = s.toString();

  if(stringValue == null){
    return stringValue;
  }

  var dotOccurences = (stringValue.match(/\./g) || [])?.length;

  if(dotOccurences != null && dotOccurences > 1){
    stringValue = stringValue.replace(/\./g, '');
  }

  var commaOccurences = (stringValue.match(/,/g) || [])?.length;

  if(commaOccurences != null && commaOccurences > 1){
    stringValue = stringValue.replace(',', '');
  }

  var DotIndex = 0;
  var CommaIndex = 0;

  for(var i=0;i<stringValue.length; i++){
    if(stringValue[i] == ','){
      CommaIndex = JSON.parse(JSON.stringify(i));
    }
    else if(stringValue[i] == '.'){
      DotIndex = JSON.parse(JSON.stringify(i));
    }
  }

  if(DotIndex < CommaIndex && DotIndex != 0){
    stringValue = this.swap(stringValue, DotIndex, CommaIndex);
  }
  else if(DotIndex == 0 && CommaIndex > 0){
    stringValue = stringValue.replace(',', '.');
  }

  return stringValue;
}

 swap(arr, first, last){
  arr = arr.split('');    //to array
  var temp = arr[first];    
  arr[first] = arr[last];
  arr[last] = temp;
  arr = arr.join("").toString()    //to string
  return arr;
}

ProofNormalizationLastCharacters(stringValue) : string {
  if(stringValue.length >= 2){
    var last2 = stringValue.slice(-2);
  }

  if(last2[0] == ',' || last2[0] == '.'){
    stringValue = stringValue +"0";
  }

  return stringValue;
}

GetCompanyNotificationsFilteredCOUNT(IsSeen:boolean, firstLoad:boolean){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Pager:this.CompanyNotificationPager,
    IsSeen:IsSeen
  };

  this.loading = true;

  this.service.GetCompanyNotificationsFilteredCOUNT(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CompanyNotificationPager = response["Pager"];

      if(firstLoad){
        this.UnseenCompanyNotificationPager = response["Pager"];
      }
    }
   
    this.loading = false;
  });
}

ShowNotificationCenter:boolean;

OpenNotificationCenter(){
  this.ShowNotificationCenter = true;
  this.GetCompanyNotificationsFiltered(null);
}

GetCompanyNotificationsFiltered(IsSeen:boolean){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Pager:this.CompanyNotificationPager,
    IsSeen:IsSeen
  };

  this.loading = true;

  this.service.GetCompanyNotificationsFiltered(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CompanyNotifications = response["Notifications"];
    }
   
    this.loading = false;
  });
}

ReadNotification(n){
  var notifications = [];
  notifications.push(n);
  this.ReadCompanyNotifications(notifications);
}

ReadCompanyNotifications(notifications){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Pager:this.CompanyNotificationPager,
    Notifications:notifications
  };

  this.service.ReadCompanyNotifications(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CompanyNotifications.forEach(n => {
        
        for(var i=0;i<notifications.length;i++){
          if(notifications[i].ID == n.ID){
            n.IsSeen = !notifications[i].IsSeen;
          }
        }
      });
    }
   
  });
}

UnreadNotification(n){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Pager:this.CompanyNotificationPager,
    Notification:n
  };

  this.loading = true;

  this.service.UnreadNotification(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CompanyNotifications.forEach(element => {
        if(element.ID == n.ID){
          element.IsSeen = response["Notification"].IsSeen;
        }
      });
    }
   
    this.loading = false;
  });
}

DeleteCompanyNotification(n){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Pager:this.CompanyNotificationPager,
    Notification:n
  };

  this.loading = true;

  this.service.DeleteCompanyNotification(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CompanyNotifications = this.CompanyNotifications.filter(x => x.ID != n.ID);
      this.GetCompanyNotificationsFilteredCOUNT(false,true);
    }
   
    this.loading = false;
  });
}

UpdateUserLastUsedCompany(CompanyID:number){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    LastUsedCompanyID:CompanyID,
    UserID:this.User.Id
  };

  this.loading = true;

  this.service.UpdateUserLastUsedCompany(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.RedirectToURLWithUrlForcedChange("/dashboard/stats");
    }
   
    this.loading = false;
  });
}

GetUserLastUsedCompany(CompanyID:number){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id
  };

  this.loading = true;

  this.service.GetUserLastUsedCompany(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      
    }
   
    this.loading = false;
  });
}

GetUser(ID:string, WithDetails:boolean){
  var request = {
    id:ID,
    Language:this.getLanguage(),
    User:this.User,
    WithDetails:WithDetails
  };

  this.service.GetUser(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.User = response["User"];

      localStorage.removeItem("User");
      localStorage.setItem('User', JSON.stringify(this.User));
    }
  });
}

RedirectToURLWithUrlChange(url:string){
  this.router.navigate([url], { replaceUrl: true }); 
}

RedirectToURLWithUrlChangeNewTab(url:string){
  window.open(url, '_blank');
}

RedirectToURLWithUrlForcedChange(url:string){
  this.loading = true;
  
  const navigationExtras: NavigationExtras = {
    skipLocationChange: false,
    replaceUrl: true
  };
  this.router.navigate([url], navigationExtras);
  setTimeout(() => window.location.reload(), 250);
}

GoToDocumentPage(s:any){

  const nextUrl = this.router.serializeUrl(this.router.createUrlTree(['dashboard/document/view'], { queryParams: { DocumentID: s.DocumentID, TypeID: s.SearchResultType.ID } }));
  window.open(nextUrl, '_blank');
  // var url = "dashboard/document/view";
  // this.router.navigate([url], { queryParams: { DocumentID: s.DocumentID, TypeID: s.SearchResultType.ID }, replaceUrl: true }); 
}

ShowAppsSelect:boolean = false;

OpenAppsSelect(){
  this.GetUserAppAccess();
}

SwitchApplication(){
  this.CurrentApp = JSON.parse(JSON.stringify(this.AuxCurrentApp));
  this.UpdateUserLastSelectedApplication(this.CurrentApp);
}

UpdateUserLastSelectedApplication(App:any){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id,
    ApplicationID:App.ID
  };

  this.loading = true;

  this.service.UpdateUserLastSelectedApplication(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.User.Rights.Application = JSON.parse(JSON.stringify(App));
      this.User.AppAccess.forEach(AppAccess => {
        if(AppAccess.Application.ID == App.ID){
          AppAccess.IsSelected = true;
        }
        else{
          AppAccess.IsSelected = false;
        }
      });

      localStorage.setItem('User', JSON.stringify(this.User));
      this.RedirectToURLWithUrlChangeNewTab(App.MainURL);
      this.ShowAppsSelect = false;
    }
 
    this.loading = false;
  });
}

EliminateEmailDocument(doc:any){
  this.EmailDocuments = this.EmailDocuments.filter(x => x.ID != doc.ID);
}

SendInvoicesNotification(){

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Invoices:this.EmailDocuments,
    CurrentSMTPEmail:this.CurrentSMTPEmail,
    CurrenctSMTP:this.CurrenctSMTP,
  };

  this.ShowEmailBulkSendContainer = false;
  this.service.SendInvoicesNotification(request).subscribe(response => {
 
    if(response["Status"] == -1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }
  });
}

ShowOverdueInvoiceNotificationContainer:boolean;
OverdueInvoiceNotificationEmailBody:string;
OverdueInvoiceNotificationEmailSubject:string;
OverdueInvoiceNotificationEmailAttachments:any[];

GeneratePartnerNotificationEmailSubjectAndBody(PartnerID:string, emailNotificationType:any, ForceAllAttachments:boolean = true, filter:any = null, eAutomatedTask:number = null){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    PartnerID:PartnerID,
    EmailNotificationType:emailNotificationType,
    ForceAllAttachments:ForceAllAttachments,
    WithExcelSummary:true,
    Filter:filter,
    eAutomatedTask:eAutomatedTask,
  };

  this.loading = true;

  this.service.GeneratePartnerNotificationEmailSubjectAndBody(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrenctSMTP = response["CurrentSMTP"];
      this.SMTPEmails = response["SendingEmails"];
      this.CurrentSMTPEmail = this.SMTPEmails[0];
      this.SMTPConfigs = response["SMTPConfigs"];
      this.Partner = response["Partner"];
      this.OverdueInvoiceNotificationEmailBody = response["Body"];
      this.OverdueInvoiceNotificationEmailSubject = response["Subject"];
      this.OverdueInvoiceNotificationEmailAttachments = response["Attachments"];

      this.ShowOverdueInvoiceNotificationContainer = true;
    }

    this.loading = false;
  });
}

GeneratePaymentDocumentEmail(payments:any[], p:any){

  payments.forEach(element => {
    if(element.UIID == p.UIID){
      element.IsSelected = true;
    }
  });

  payments = JSON.parse(JSON.stringify(payments.filter(x => x.IsSelected == true)));

  var request = {
    User:this.User,
    Language:this.getLanguage(),
    Payments:payments,
  };

  this.loading = true;

  this.service.GeneratePaymentDocumentEmail(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CurrenctSMTP = response["CurrentSMTP"];
      this.SMTPEmails = response["SendingEmails"];
      this.CurrentSMTPEmail = this.SMTPEmails[0];
      this.SMTPConfigs = response["SMTPConfigs"];
      this.Partner = response["Partner"];
      this.OverdueInvoiceNotificationEmailBody = response["Body"];
      this.OverdueInvoiceNotificationEmailSubject = response["Subject"];
      this.OverdueInvoiceNotificationEmailAttachments = response["Attachments"];

      this.PayStub = response["PayStub"];
      this.ShowOverdueInvoiceNotificationContainer = true;
    }

    this.loading = false;
  });
}

PayStub:any;

ImplementPaystub(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    PayStub:this.PayStub
  };

  this.loading = true;

  this.service.ImplementPaystub(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowOverdueInvoiceNotificationContainer = false;
    }

    this.loading = false;
  });
}

EliminateAttachment(ID:string){
 this.OverdueInvoiceNotificationEmailAttachments = this.OverdueInvoiceNotificationEmailAttachments.filter(x => x.ID != ID);
}

SendOverdueInvoiceNotificationEmail(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    SMTP:this.CurrenctSMTP,
    FromEmail:this.CurrentSMTPEmail,
    ToEmail:this.Partner.ContactInfo.Email,
    Body:this.OverdueInvoiceNotificationEmailBody,
    Subject:this.OverdueInvoiceNotificationEmailSubject,
    Attachments:this.OverdueInvoiceNotificationEmailAttachments
  };

  this.loading = true;

  this.service.SendOverdueInvoiceNotificationEmail(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.openSnackBar(response["Message"], "OK", "light-info-snackbar");
    }

    this.loading = false;
  });
}

GetUserAppAccess(){
  var request = {
    User:this.User,
    Language:this.getLanguage(),
    UserID:this.User.Id
  };

  this.loading = true;

  this.service.GetUserAppAccess(request).subscribe(response => {
 
    if(response["Status"] != 1){
      this.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Applications = response["AllowedApplications"];
      this.AuxCurrentApp = JSON.parse(JSON.stringify(this.CurrentApp));
      this.ShowAppsSelect = true;
    }

    this.loading = false;
  });
}

private dbName = 'accountingDatabase'; // The name of your database
private dbVersion = 1; // Database version

private openIndexedDBDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(this.dbName, this.dbVersion);

    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = request.result;
      // Create an object store if it doesn't exist
      if (!db.objectStoreNames.contains('objects')) {
        db.createObjectStore('objects', { keyPath: 'id' });
      }
    };

    request.onsuccess = () => {
      resolve(request.result);
    };

    request.onerror = (event) => {
      reject(request.error);
    };
  });
}

// Write any object to the database
public writeIndexedDBObject<T>(key: string, value: T): Promise<void> {
  return this.openIndexedDBDatabase().then((db) => {
    return new Promise<void>((resolve, reject) => {
      const transaction = db.transaction('objects', 'readwrite');
      const store = transaction.objectStore('objects');
      const objectToStore = { id: key, value: JSON.stringify(value) }; // Serialize the object to JSON
      const request = store.put(objectToStore);

      request.onsuccess = () => {
        resolve();
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  });
}

// Read the exact JSON value from the database
public readIndexedDBObject<T>(key: string): Promise<T | undefined> {
  return this.openIndexedDBDatabase().then((db) => {
    return new Promise<T | undefined>((resolve, reject) => {
      const transaction = db.transaction('objects', 'readonly');
      const store = transaction.objectStore('objects');
      const request = store.get(key);

      request.onsuccess = () => {
        if (request.result) {
          resolve(JSON.parse(request.result.value)); // Deserialize the object from JSON
        } else {
          resolve(undefined);
        }
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  });
}

public deleteIndexedDBObject(key: string): Promise<void> {
  return this.openIndexedDBDatabase().then((db) => {
    return new Promise<void>((resolve, reject) => {
      const transaction = db.transaction('objects', 'readwrite');
      const store = transaction.objectStore('objects');
      const deleteRequest = store.delete(key);

      deleteRequest.onsuccess = () => {
        resolve(); // Resolve the promise when delete is successful
      };

      deleteRequest.onerror = () => {
        reject(deleteRequest.error); // Reject with the error if deletion fails
      };
    });
  });
}
}
